import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class RememberPasswordRequest extends GenericRequest {

    email;

    constructor(email) {
        super(METHOD_POST, ApiEndpoints.REMEMBER_PASSWORD);

        this.email = email;
    }

    overrideRequest() {
        const request = {};
        if ( this.email ) request.email = this.email;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/login/ws/RememberPasswordRequest.js